import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { Code } from './app.service';
import { Car } from './member-kanri/car.service';


export class SERVER {

    //AWS demo
    //public static get baseURL(): string { return "https://cs.e-corporation.co.jp:8443/cargo"; }
    //public static get baseIP(): string { return "https://cs.e-corporation.co.jp:8443"; }
    //public static get socketURL(): string { return "wss://cs.e-corporation.co.jp:8443/ws/cargo"; }
    //public static get baseURL(): string { return "https://18.180.199.195:8443/cargo"; }
    //public static get baseIP(): string { return "https://18.180.199.195:8443"; }
    //public static get socketURL(): string { return "wss://18.180.199.195:8443/ws/cargo"; }

    // 本番
    public static get baseURL(): string { return "https://csd.e-corporation.co.jp:8443/cargo"; }
    public static get baseIP(): string { return "https://csd.e-corporation.co.jp:8443"; }
    public static get socketURL(): string { return "wss://csd.e-corporation.co.jp:8443/ws/cargo"; }
    public static get caseSocketURL(): string { return "wss://csd.e-corporation.co.jp:8443/ws/case"; }

    // local test
    // public static get baseURL(): string { return "https://csd.e-corporation.co.jp:8445/cargo"; }
    // public static get baseIP(): string { return "https://csd.e-corporation.co.jp:8445"; }
    // public static get socketURL(): string { return "wss://csd.e-corporation.co.jp:8445/ws/cargo"; }
    // public static get caseSocketURL(): string { return "wss://csd.e-corporation.co.jp:8445/ws/case"; }

    // 検証
    // public static get baseURL(): string { return "http://54.150.250.72:8445/cargo"; }
    // public static get baseIP(): string { return "http://54.150.250.72:8445"; }
    // public static get socketURL(): string { return "wss://54.150.250.72:8445/ws/cargo"; }
    // public static get caseSocketURL(): string { return "wss://54.150.250.72:8445/ws/case"; }

    /*
    //local test
    public static get baseURL(): string { return "https://192.168.100.25:8443/cargo"; }
    public static get baseIP(): string { return "https://192.168.100.25:8443"; }
    public static get socketURL(): string { return "wss://192.168.100.25:8443/ws/cargo"; }
    */
}
export class CARGO_LIST_TYPE {
    public static readonly ORDER: string = 'order';
    public static readonly SHIP: string = 'ship';
    public static readonly REQUEST: string = 'request';
    public static readonly DONE: string = 'done';
}
export class IMPORTANCE_TYPE {
    public static readonly HIGH: string = '3';
    public static readonly MIDDLE: string = '2';
    public static readonly LOW: string = '1';
}
export class CARGO_STATUS {
    public static readonly REGIST: string = '01';
    public static readonly ACCEPT: string = '11';
    public static readonly MATCH_CAR: string = '13';
    public static readonly TRANS_START: string = '51';
    public static readonly LOAD: string = '52';
    public static readonly DROP: string = '53';
    public static readonly TRANS_END: string = '54';
    public static readonly NO_ACCEPT: string = '88';
    public static readonly CANCEL: string = '99';
}
export class CAR_STATUS {
    public static readonly NO_TRANS: string = '0';
    public static readonly IN_TRANS: string = '1';
    public static readonly WILL_TRANS: string = '2';
}
export class LOGON_INFO {
    public static get TOKEN(): string { return sessionStorage.getItem("token") };
    public static get USER_ID(): string { return sessionStorage.getItem("logon_user_id"); };
    public static get USER_NAME(): string { return sessionStorage.getItem("logon_user_name"); };
    public static get USER_DIV(): string { return sessionStorage.getItem("logon_user_div"); };
    public static get COMP_ID(): string { return sessionStorage.getItem("logon_comp_id") };
    public static get COMP_TYPE(): string { return sessionStorage.getItem("logon_comp_type"); };
    public static get MENU_ROLE(): string { return sessionStorage.getItem("logon_menu_role"); };
    public static get COMP_LAT(): string { return sessionStorage.getItem("logon_comp_lat") };
    public static get COMP_LNG(): string { return sessionStorage.getItem("logon_comp_lng") };
    public static get PARENT_COMP_ID(): string { return sessionStorage.getItem("logon_parent_comp_id"); };
    public static get CAR_ID(): number { return +sessionStorage.getItem("logon_car_id"); };
}
export class CODE {
    public static get TIME_DIVIDE(): Code[] { return JSON.parse(sessionStorage.getItem('TIME_DIVIDE')); };
    public static get LOAD_METHOD(): Code[] { return JSON.parse(sessionStorage.getItem('LOAD_METHOD')); };
    public static get CAR_TYPE(): Code[] { return JSON.parse(sessionStorage.getItem('CAR_TYPE')); };
    public static get CAR_MAKER(): Code[] { return JSON.parse(sessionStorage.getItem('CAR_MAKER')); };
    public static get COMP_TYPE(): Code[] { return JSON.parse(sessionStorage.getItem('COMP_TYPE')); };
    public static get TODOHUKEN(): Code[] { return JSON.parse(sessionStorage.getItem('TODOHUKEN')); };
    public static get CAR_ABILITY(): Code[] { return JSON.parse(sessionStorage.getItem('CAR_ABILITY')); };
    public static get CHARGE_UNIT(): Code[] { return JSON.parse(sessionStorage.getItem('CHARGE_UNIT')); };
    public static get LICENSE_TYPE(): Code[] { return JSON.parse(sessionStorage.getItem('LICENSE_TYPE')); };

    // (2024.04)メニュー選択追加
    public static get CAR_MENU(): Code[] { return JSON.parse(sessionStorage.getItem('CAR_MENU')); };
    public static get STATE_MENU(): Code[] { return JSON.parse(sessionStorage.getItem('STATE_MENU')); };
    public static get STATE_CLTR(): Code[] { return JSON.parse(sessionStorage.getItem('STATE_CLTR')); };
}
export class COMP_TYPE {
    public static readonly ADMIN: string = 'S';
    public static readonly HEAD: string = 'H';
    public static readonly BRANCH: string = 'B';
    public static readonly CLIENT: string = 'C';
    public static readonly PARTNER: string = 'P';
}
export class SHARE_FLAG {
    public static readonly ALL: string = 'A';
    public static readonly COMPANY: string = 'C';
    public static readonly PARTNER: string = 'P';
    public static readonly BRANCH: string = 'B';
}
export class SCHEDULE {
    public static readonly WEEKDAY_SIZE: number = 9;
    public static readonly CELL_WIDTH: number = 7;
    public static readonly CELL_HEIGHT: number = 6;

    public static readonly WEEKDAY_SIZE_SM: number = 7;
    public static readonly CELL_WIDTH_SM: number = 4;
    public static readonly CELL_HEIGHT_SM: number = 4.2;

    public static readonly CAR_SCHEDULE: string = 'C';
    public static readonly DRIVER_SCHEDULE: string = 'D';
    public static readonly TRANS_SCHEDULE: string = 'T';
}
export class DATEPICKER {
    public static readonly baseDatePickerOptions = {
        dateFormat: 'yyyy/mm/dd',
        dayLabels: {su: '日', mo: '月', tu: '火', we: '水', th: '木', fr: '金', sa: '土'},
        monthLabels: { 1: '1月', 2: '2月', 3: '3月', 4: '4月', 5: '5月', 6: '6月', 7: '7月', 8: '8月', 9: '9月', 10: '10月', 11: '11月', 12: '12月' },
        todayBtnTxt: '今日',
        minYear: 2000,
        maxYear: 2050,
        allowSelectionOnlyInCurrentMonth: false,
        disableUntil: {year: 2000, month: 1, day: 1},
        firstDayOfWeek: 'su',
        highlightDates: [{year: 2010, month: 7, day: 16}],
        selectorHeight: '260px',
        selectorWidth: '290px',
        ariaLabelPrevMonth: '前月',
        ariaLabelNextMonth: '次月'
    };

    public static get myDatePickerOptions(): INgxMyDpOptions {
        let options = Object.assign({},this.baseDatePickerOptions);

        let holiday = JSON.parse(sessionStorage.getItem("HOLIDAY"));
        options.highlightDates = holiday;

        let d: Date = new Date();
        d.setDate(d.getDate()-8);
        options.disableUntil = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};

        return options;
    }

    public static get myDatePickerOptions_noDisableUntil(): INgxMyDpOptions {
        let options = Object.assign({},this.baseDatePickerOptions);

        let holiday = JSON.parse(sessionStorage.getItem("HOLIDAY"));
        options.highlightDates = holiday;

        return options;
    }
}
export class USER_TYPE {
    public static readonly ADMIN: string = '0';
    public static readonly CLIENT: string = '9';
    public static readonly DRIVER: string = '3';
    public static readonly TRANS_MANAGER: string = '1';
    public static readonly TRANS_HAISHAMAN: string = '2';
}

export class MENU_ROLE {
    public static readonly MANAGER: string = 'ROLE_MANAGER';
    public static readonly NORMAL: string = 'ROLE_NORMAL';
}


export class AppConstants {

    public static readonly LAUNCHING_YEAR: number = 2018;

    public static readonly PRINT_FORM_PATH: string = "/assets/print-form/";

    public static readonly PAGE_SIZE: number = 100;
    public static readonly PAGE_SIZE_LARGE: number = 100;

    public static readonly BASIC_LAT: number = 35.181508;
    public static readonly BASIC_LNG: number = 136.906495;

    public static readonly LOAD: string = 'load';
    public static readonly DROP: string = 'drop';

    public static readonly REGIST: string = 'R';
    public static readonly UPDATE: string = 'U';
    public static readonly SHARE: string = 'S';
    public static readonly ACCEPT: string = 'A';
    public static readonly ACCEPT_CANCEL: string = 'AC';
    public static readonly REPORT: string = 'TR';
}



// WEBPACK FOOTER //
// ./src/app/app.constants.ts